// Medyatik Interactive - Büyüme Sistemleri Veri Dosyası
// Yeni nesil hizmet mimarisi

export const positioning = {
  oneLiner: "Dijital büyümeyi; strateji, teknoloji ve yapay zekâ ile tasarlayan ajans.",
  corePromise: "Sadece tasarım/yazılım/otomasyon değil; hissettiren, etkileyen ve sempati kazandıran sistemler kurarız.",
  workingModel: "Proje bazlı (Sprint + teslim edilebilir büyüme çıktıları).",
  ethicalFrame: "Etik ikna: şeffaf, sürdürülebilir, güven odaklı iletişim ve deneyim tasarımı."
};

// Başarı Hikayeleri / Vaka Çalışmaları
export const caseStudies = {
  'digital-experience': {
    title: 'E-Ticaret Dönüşüm Optimizasyonu',
    client: 'Premium Moda Markası',
    challenge: 'Yüksek trafik, düşük dönüşüm oranı (%1.2)',
    solution: 'Nöro-UX analizi, checkout akışı yeniden tasarımı, güven sinyalleri entegrasyonu',
    results: [
      { value: '+187%', label: 'CVR Artışı' },
      { value: '-42%', label: 'Bounce Rate' },
      { value: '+156%', label: 'Sepet Tamamlama' }
    ],
    quote: 'Sadece tasarım değil, ziyaretçinin zihnini okudular.',
    duration: '6 hafta'
  },
  'authority-engine': {
    title: 'B2B SaaS Organik Büyüme',
    client: 'Kurumsal Yazılım Şirketi',
    challenge: 'Reklam bağımlılığı, düşük organik lead',
    solution: 'Topical authority stratejisi, pillar content sistemi, LinkedIn thought leadership',
    results: [
      { value: '+340%', label: 'Organik Trafik' },
      { value: '+89%', label: 'Nitelikli Lead' },
      { value: '12→1', label: 'Sektör Sıralaması' }
    ],
    quote: 'Artık müşteriler bizi arıyor.',
    duration: '4 ay'
  },
  'performance-accelerator': {
    title: 'Lead Generation Kampanyası',
    client: 'Eğitim Teknolojisi Startup',
    challenge: 'Yüksek CAC, düşük ROAS',
    solution: 'Psikoloji odaklı kreatif, huni optimizasyonu, teklif yeniden tasarımı',
    results: [
      { value: '-58%', label: 'CAC Düşüşü' },
      { value: '+240%', label: 'ROAS Artışı' },
      { value: '3.2x', label: 'Lead Artışı' }
    ],
    quote: 'Aynı bütçeyle 3 kat fazla müşteri.',
    duration: '8 hafta'
  },
  'data-loyalty': {
    title: 'Retention & LTV Optimizasyonu',
    client: 'Abonelik E-Ticaret',
    challenge: '%18 aylık churn, düşük tekrar satın alma',
    solution: 'Segment bazlı retention akışları, win-back kampanyaları, sadakat programı',
    results: [
      { value: '-62%', label: 'Churn Azalması' },
      { value: '+78%', label: 'Tekrar Satın Alma' },
      { value: '+45%', label: 'LTV Artışı' }
    ],
    quote: 'Müşteri kaybı artık kontrol altında.',
    duration: '3 ay'
  },
  'aifabric-enterprise': {
    title: 'Satış Ekibi AI Entegrasyonu',
    client: 'Kurumsal Danışmanlık Firması',
    challenge: 'Uzun satış döngüsü, düşük teklif kalitesi',
    solution: 'AI destekli teklif hazırlama, satış koçluğu sistemi, CRM otomasyonu',
    results: [
      { value: '-40%', label: 'Teklif Süresi' },
      { value: '+67%', label: 'Kapanış Oranı' },
      { value: '15 saat', label: 'Haftalık Tasarruf' }
    ],
    quote: 'AI satış ekibimizin süper gücü oldu.',
    duration: '6 hafta'
  }
};

export const growthSystems = [
  {
    id: 'digital-experience',
    slug: 'dijital-deneyim-algi-mimarisi',
    name: 'Dijital Deneyim & Algı Mimarisi',
    aka: 'Zihin Tasarımı',
    icon: 'Brain',
    color: 'violet',
    isNew: false,
    shortDescription: 'Web/ürün deneyimini; nöro-UX, mesaj hiyerarşisi ve davranışsal akışlarla, ziyaretçiyi güven ve aksiyona taşıyan bir algı sistemine dönüştürür.',
    whatItIs: 'Web/ürün deneyimini; nöro-UX, mesaj hiyerarşisi ve davranışsal akışlarla, ziyaretçiyi güven ve aksiyona taşıyan bir algı sistemine dönüştürür.',
    problem: 'Çoğu web sitesi sadece "güzel görünmeye" odaklanır. Ancak görsel estetik tek başına dönüşüm getirmez. Ziyaretçiler siteye gelir, gezinir ve... çıkar.',
    whyTraditionalFails: 'Geleneksel tasarım yaklaşımı, kullanıcının bilinçaltı karar mekanizmalarını göz ardı eder. Dikkat ekonomisinde, ilk 3 saniyede güven inşa edemezseniz, ziyaretçiyi kaybedersiniz.',
    bestFor: [
      'Web sitesi/ürün dönüşümünü artırmak isteyen markalar',
      'Premium algı ve güven inşa etmek isteyen işletmeler',
      'Hizmet/ürün anlatımında netlik ve sempati arayan ekipler'
    ],
    modules: [
      { name: 'Nöro-UX & UI Tasarımı', description: 'Göz takibi prensipleri ve bilişsel yük optimizasyonu' },
      { name: 'Hipnotik Arayüz ve Akış Tasarımı', description: 'Etik çerçevede dikkat yönlendirme' },
      { name: 'Mesaj Hiyerarşisi & Sayfa Mimarisi', description: 'Doğru mesajı doğru sırada iletme' },
      { name: 'Landing Page & Dönüşüm Odaklı Tasarım', description: 'Aksiyon odaklı sayfa tasarımı' },
      { name: 'A/B Teste Hazır Tasarım Sistemi', description: 'Sürekli optimizasyon altyapısı' }
    ],
    aifabricIntegration: [
      'Gerçek zamanlı davranış analizi (scroll, tıklama, terk)',
      'Segment bazlı içerik/CTA varyant önerileri',
      'Dönüşüm darboğazı tespiti ve önceliklendirme'
    ],
    deliverables: [
      'UX akışları + wireframe',
      'UI kit / tasarım sistemi (dark premium)',
      'Geliştirilebilir prototip',
      'Dönüşüm odaklı sayfa seti (LP + kritik sayfalar)'
    ],
    successMetrics: [
      { metric: 'CVR', label: 'Dönüşüm Oranı' },
      { metric: 'Bounce Rate', label: 'Hemen Çıkma Oranı' },
      { metric: 'Form Completion', label: 'Form Tamamlama' },
      { metric: 'Engagement', label: 'Sayfa Etkileşimi' }
    ]
  },
  {
    id: 'authority-engine',
    slug: 'otorite-talep-motoru',
    name: 'Otorite & Talep Motoru',
    aka: 'Pazar Hakimiyeti',
    icon: 'Crown',
    color: 'emerald',
    isNew: false,
    shortDescription: "SEO'yu bir 'trafik aracı' değil, sektörde otorite ve nitelikli talep üreten bir içerik ve algı motoru olarak kurgular.",
    whatItIs: "SEO'yu bir 'trafik aracı' değil, sektörde otorite ve nitelikli talep üreten bir içerik ve algı motoru olarak kurgular.",
    problem: 'SEO genellikle "anahtar kelime sıkıştırma" olarak algılanır. Sonuç: Trafik gelir ama dönüşüm gelmez. Ziyaretçi niteliksiz, marka algısı zayıf.',
    whyTraditionalFails: 'Klasik SEO yaklaşımı, arama motorlarını memnun etmeye odaklanır, insanları değil. Topical authority olmadan, algoritma güncellemelerinde sıralama kaybı kaçınılmazdır.',
    bestFor: [
      'Sektörde liderlik algısı kurmak isteyen markalar',
      'Nitelikli lead ve inbound talep arayan işletmeler',
      'Uzun vadeli büyümeyi içerikle ölçeklemek isteyen ekipler'
    ],
    modules: [
      { name: 'Mesaj Mimarisi', description: 'Hipnotik dil kalıplarıyla etik çerçevede' },
      { name: 'Authority SEO', description: 'Konu kümeleri ve topical authority' },
      { name: 'İçerik Sistem Tasarımı', description: 'Brief → üretim → dağıtım akışı' },
      { name: 'Lead Magnet & İçerik Hunileri', description: 'Değer odaklı lead yakalama' },
      { name: 'Dijital İtibar & Liderlik Konumlandırması', description: 'Thought leadership stratejisi' }
    ],
    aifabricIntegration: [
      'Konu kümesi ve rekabet boşluğu analizi',
      'Tahminsel içerik performans skoru',
      'SERP niyeti ve dönüşüm niyeti eşleştirme'
    ],
    deliverables: [
      'SEO strateji dokümanı + içerik haritası',
      'Aylık/çeyreklik içerik planı',
      'Pillar page + cluster içerik seti',
      'LinkedIn/PR/otorite görünürlük planı'
    ],
    successMetrics: [
      { metric: 'Organic Leads', label: 'Organik Lead' },
      { metric: 'Brand Search', label: 'Marka Araması' },
      { metric: 'Topical Authority', label: 'Konu Otoritesi' },
      { metric: 'Content Sales', label: 'İçerikten Satış' }
    ]
  },
  {
    id: 'performance-accelerator',
    slug: 'performans-ikna-hizlandirici',
    name: 'Performans & İkna Hızlandırıcı',
    aka: 'Satış ve Dönüşüm',
    icon: 'Rocket',
    color: 'pink',
    isNew: false,
    shortDescription: "Reklamı 'harcama' olmaktan çıkarır; ikna psikolojisiyle tasarlanan kreatif, huni ve ölçüm sistemleriyle büyümeyi hızlandırır.",
    whatItIs: "Reklamı 'harcama' olmaktan çıkarır; ikna psikolojisiyle tasarlanan kreatif, huni ve ölçüm sistemleriyle büyümeyi hızlandırır.",
    problem: 'Reklam bütçeleri harcanıyor ama ROI belirsiz. Kreatifler test edilmeden yayınlanıyor, huniler optimize edilmiyor.',
    whyTraditionalFails: 'Geleneksel performans pazarlama, sadece metriklere odaklanır. Ancak tıklama almak yetmez; tıklayanı ikna etmek gerekir. Psikoloji olmadan, bütçe israftır.',
    bestFor: [
      'Reklam bütçesini verimli büyütmek isteyen markalar',
      'Lead/satış hacmini artırmak isteyen ekipler',
      'Kreatif + mesaj + teklif bütünlüğü kurmak isteyen işletmeler'
    ],
    modules: [
      { name: 'Psikoloji Odaklı Kreatif & Copy', description: 'İkna prensipleriyle tasarım' },
      { name: 'Dönüşüm Hunisi Mühendisliği', description: 'Funnel optimizasyonu' },
      { name: 'Teklif Tasarımı ve Konumlandırma', description: 'Offer engineering' },
      { name: 'Kampanya Yapısı ve Ölçümleme', description: 'Event tracking sistemi' },
      { name: 'CRO', description: 'Conversion Rate Optimization' }
    ],
    aifabricIntegration: [
      'Otomatik A/B test önerileri ve varyant üretim briefleri',
      'Bütçe/kanal performans anomalisi uyarıları',
      'Dönüşüm hunisi sürtünme noktası tespiti'
    ],
    deliverables: [
      'Kampanya planı + kreatif brief seti',
      'Landing page + reklam mesaj eşleşmesi',
      'Ölçümleme şeması (event plan)',
      'Haftalık performans aksiyon listesi'
    ],
    successMetrics: [
      { metric: 'CAC', label: 'Müşteri Edinme Maliyeti' },
      { metric: 'ROAS', label: 'Reklam Getirisi' },
      { metric: 'Lead-to-Close', label: 'Kapanış Oranı' },
      { metric: 'Revenue Growth', label: 'Gelir Artışı' }
    ]
  },
  {
    id: 'data-loyalty',
    slug: 'veri-zekasi-sadakat-sistemleri',
    name: 'Veri Zekası & Sadakat Sistemleri',
    aka: 'Retention & LTV',
    icon: 'Heart',
    color: 'amber',
    isNew: true,
    shortDescription: 'Büyümeyi sadece yeni müşteri kazanımıyla değil; elde tutma, tekrar satın alma ve yaşam boyu değer artırımıyla sürdürülebilir hale getirir.',
    whatItIs: 'Büyümeyi sadece yeni müşteri kazanımıyla değil; elde tutma, tekrar satın alma ve yaşam boyu değer (LTV) artırımıyla sürdürülebilir hale getirir.',
    problem: 'Markalar sürekli yeni müşteri peşinde koşar. Mevcut müşteriler ihmal edilir. Sonuç: Yüksek churn, düşük LTV, sürdürülemez büyüme.',
    whyTraditionalFails: 'Klasik pazarlama, acquisition odaklıdır. Ancak yeni müşteri edinme maliyeti, mevcut müşteriyi tutmanın 5-7 katıdır. Retention olmadan, büyüme sürdürülemez.',
    bestFor: [
      'Tek seferlik satıştan çıkıp tekrar satış isteyen markalar',
      'Churn düşürmek isteyen abonelik/servis işletmeleri',
      'CRM ve müşteri iletişimini güçlendirmek isteyen ekipler'
    ],
    modules: [
      { name: 'LTV Optimizasyonu ve Segmentasyon', description: 'Müşteri değeri maksimizasyonu' },
      { name: 'Retention Akışları', description: 'E-posta/SMS/WhatsApp stratejisi' },
      { name: 'Sadakat & Referans Mekanikleri', description: 'Loyalty program tasarımı' },
      { name: 'Müşteri Yolculuğu Analitiği', description: 'Journey mapping ve analiz' },
      { name: 'Win-back Stratejileri', description: 'Geri kazanım kampanyaları' }
    ],
    aifabricIntegration: [
      'Churn riski tahmini ve erken uyarı',
      'Segment bazlı teklif/mesaj önerileri',
      'Kohort analizi ve büyüme içgörüleri'
    ],
    deliverables: [
      'Retention strateji dokümanı',
      'Segmentler + mesaj çerçevesi',
      'Yaşam döngüsü iletişim planı',
      'Kohort & LTV raporlama şablonları'
    ],
    successMetrics: [
      { metric: 'Retention Rate', label: 'Elde Tutma Oranı' },
      { metric: 'Repeat Purchase', label: 'Tekrar Satın Alma' },
      { metric: 'Churn', label: 'Kayıp Oranı' },
      { metric: 'LTV', label: 'Yaşam Boyu Değer' }
    ]
  },
  {
    id: 'aifabric-enterprise',
    slug: 'aifabric-kurumsal-entegrasyon',
    name: 'aifabric Kurumsal Entegrasyon & Danışmanlık',
    aka: 'İç Süreçlerde AI Dönüşümü',
    icon: 'Cpu',
    color: 'cyan',
    isNew: true,
    shortDescription: 'Yapay zekâyı sadece pazarlamada değil; satış, destek ve operasyon süreçlerinde de uygulanabilir hale getirerek verimlilik ve gelir artışı sağlar.',
    whatItIs: 'Yapay zekâyı sadece pazarlamada değil; satış, destek ve operasyon süreçlerinde de uygulanabilir hale getirerek verimlilik ve gelir artışı sağlar.',
    problem: 'Şirketler AI potansiyelini görüyor ama nereden başlayacağını bilmiyor. Pilot projeler başarısız oluyor, yatırım boşa gidiyor.',
    whyTraditionalFails: 'Teknoloji odaklı AI projeleri, iş süreçlerinden kopuk kalır. Araç satın alınır ama kullanılmaz. Veri var ama içgörüye dönüşmez.',
    bestFor: [
      'İç ekip verimliliğini artırmak isteyen işletmeler',
      'Satış/sunum süreçlerini standardize etmek isteyen ekipler',
      'Müşteri destek yükünü azaltmak isteyen organizasyonlar'
    ],
    modules: [
      { name: 'AI Kullanım Senaryosu Keşfi', description: 'Workshop ve use-case mapping' },
      { name: 'Satış & Müşteri İletişim Optimizasyonu', description: 'AI destekli satış akışları' },
      { name: 'Destek/SSS Bilgi Mimarisi', description: 'Otomasyon tasarımı' },
      { name: 'Hipnotik Satış & İkna Workshop\'ları', description: 'Taner Torun imzalı' },
      { name: 'AI Destekli Raporlama', description: 'Karar panelleri ve dashboardlar' }
    ],
    aifabricIntegration: [
      'Veriyi içgörüye çeviren zeka katmanı',
      'Süreç bazlı otomasyon önerileri',
      'Performans sinyallerini izleyen karar destek'
    ],
    deliverables: [
      'Use-case kataloğu + önceliklendirme',
      'Pilot proje planı (PoC) ve teslim çıktıları',
      'Ekip eğitim oturumu',
      'Ölçümleme ve başarı metrikleri çerçevesi'
    ],
    successMetrics: [
      { metric: 'Time Saved', label: 'Zaman Tasarrufu' },
      { metric: 'Response Time', label: 'Yanıt Süresi' },
      { metric: 'Sales Quality', label: 'Satış Kalitesi' },
      { metric: 'Cost Optimization', label: 'Maliyet Optimizasyonu' }
    ]
  }
];

export const packages = [
  {
    id: 'growth-sprint',
    name: 'Büyüme Sprinti',
    duration: '2-4 hafta',
    idealFor: 'Hızlı teşhis + hızlı kazanım',
    description: 'Mevcut durumunuzu analiz edip, en yüksek etkili aksiyonları hızla hayata geçiriyoruz.',
    includes: [
      'Mevcut durum analizi',
      'Öncelikli 3-5 aksiyon planı',
      '1 kritik sayfa/akış iyileştirmesi',
      'Ölçümleme planı'
    ],
    color: 'violet'
  },
  {
    id: 'growth-system',
    name: 'Büyüme Sistemi Kurulumu',
    duration: '6-10 hafta',
    idealFor: 'Uçtan uca sistem kurulumları',
    description: 'Seçtiğiniz büyüme sistemini sıfırdan kuruyor, aifabric ile entegre ediyoruz.',
    includes: [
      'Seçilen büyüme sistem(ler)i',
      'aifabric entegrasyon noktaları',
      'Test planı ve ölçümleme',
      'Sonuç raporu ve yol haritası'
    ],
    color: 'emerald',
    popular: true
  },
  {
    id: 'ai-pilot',
    name: 'AI Entegrasyon Pilot',
    duration: '3-6 hafta',
    idealFor: 'Kurumsal süreçte AI pilotu',
    description: 'İç süreçlerinizde AI potansiyelini keşfedip, somut bir pilot projeyle değer üretiyoruz.',
    includes: [
      'Use-case keşfi workshop',
      'Pilot kurulum (PoC)',
      'Ekip enablement',
      'Başarı metrikleri'
    ],
    color: 'cyan'
  }
];

export const methodology = {
  name: 'Taner Torun Metodolojisi',
  founder: 'Taner TORUN',
  title: 'Kurucu & Zihin Mimarı',
  experienceYears: 20,
  pillars: [
    {
      title: 'Nöro-UX',
      description: 'Bilişsel yük yönetimi ve dikkat optimizasyonu',
      icon: 'Brain'
    },
    {
      title: 'Mesaj Mimarisi',
      description: 'Hipnotik dil kalıpları (etik çerçevede)',
      icon: 'MessageSquare'
    },
    {
      title: 'Davranışsal Akış',
      description: 'Güven inşası ve aksiyon tasarımı',
      icon: 'GitBranch'
    },
    {
      title: 'Etik İkna',
      description: 'Şeffaflık ve uzun vadeli ilişki',
      icon: 'Shield'
    }
  ]
};

export const getSystemBySlug = (slug) => {
  return growthSystems.find(system => system.slug === slug);
};

export const getSystemById = (id) => {
  return growthSystems.find(system => system.id === id);
};

export default { positioning, growthSystems, packages, methodology };
